/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_PRESENTATION_LIST = gql`
  query GetPresentations(
    $options: GetManyOptions
    $filter: PresentationFilterInput
  ) {
    getPresentations(options: $options, filter: $filter) {
      content {
        country
        createdAt
        id
        name
        status
        updatedAt
        year
        type
      }
      count
      limit
      skip
    }
  }
`;

export const GET_COSTUMETYPES = gql`
  query GetCostumeTypes(
    $filter: CostumeTypeFilterInput
    $options: GetManyOptions
  ) {
    getCostumeTypes(filter: $filter, options: $options) {
      count
      limit
      skip
      content {
        name
        sectionSpecificInvites
        specialInvites
        id
        defaultInvites
        inventoryDetail {
          defaultInvitesRemaining
          defaultInvitesUsed
          sectionSpecificInvitesRemaining
          sectionSpecificInvitesUsed
          specialInvitesRemaining
          specialInvitesUsed
        }
        updateHistory {
          _id
          date
          user {
            email
            fullName
          }
          description
        }
        costumeFeatures {
          id
          name
          costumeAttributes {
            id
            name
            costumeValues {
              id
              name
            }
          }
        }
      }
    }
  }
`;
